export const TYPE_DATEFILTER_STATUS = {
  TODAY: {
    ID: 1,
    TEXT: "Today",
    SHOW_IN_MENU: true
  },
  THIS_WEEK: {
    ID: 2,
    TEXT: "This Week",
    SHOW_IN_MENU: true
  },
  THIS_MONTH: {
    ID: 3,
    TEXT: "This Month",
    SHOW_IN_MENU: true
  },
  PAST_7_DAYS: {
    ID: 4,
    TEXT: "Past 7 Days",
    SHOW_IN_MENU: true
  },
  PAST_30_DAYS: {
    ID: 5,
    TEXT: "Past 30 Days",
    SHOW_IN_MENU: true
  },
  CUSTOM_DATE: {
    ID: 6,
    TEXT: "Custom Date",
    SHOW_IN_MENU: true
  }
};

export const TYPE_DATETCOLUMN_FILTER = {
  BOOKING_DATE: {
    ID: 0,
    TEXT: "Booking Date",
    SHOW_IN_MENU: true
  },
  SERVICE_DATE: {
    ID: 1,
    TEXT: "Service Date",
    SHOW_IN_MENU: true
  }
};

export function GetFormattedDateString(value) {
  if (value) {
    let obj_date = new Date(value);
    if (obj_date) {
      let month = "" + (obj_date.getMonth() + 1);
      let day = "" + obj_date.getDate();
      let year = obj_date.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/") + " " + obj_date.toLocaleTimeString();
    }
  }
  return "";
}

export function GetFormattedDateObject(obj_date) {
  if (obj_date != null && !isNaN(obj_date.getTime())) {
    let month = "" + (obj_date.getMonth() + 1);
    let day = "" + obj_date.getDate();
    let year = obj_date.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("/") + " " + obj_date.toLocaleTimeString();
  }
  return "";
}

export function GetFormattedDateOnlyString(value) {
  if (value) {
    let obj_date = new Date(value);
    if (obj_date) {
      let month = "" + (obj_date.getMonth() + 1);
      let day = "" + obj_date.getDate();
      let year = obj_date.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    }
  }
  return "";
}

export function GetFormattedLocaleDateOnlyString(value) {
  if (value) {
    let obj_date = new Date(value);
    if (obj_date) {
      let month = "" + (obj_date.getMonth() + 1);
      let day = "" + obj_date.getDate();
      let year = obj_date.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    }
  }
  return "";
}

export function GetLocaleISODateOnlyObject(obj_date) {
  if (obj_date) {
    let month = "" + (obj_date.getMonth() + 1);
    let day = "" + obj_date.getDate();
    let year = obj_date.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  return "";
}

export function GetFormattedTimeOnlyString(value) {
  if (value) {
    let obj_time = value.split(":");
    // e.g: 00:00:00, got 3 length split by `:`
    if (obj_time.length >= 2) {
      let ampm = "";
      let strHour = "";
      let hour = parseInt(obj_time[0]);
      // 00, refer to 12 am
      if (hour == 0 || hour == 24) {
        ampm = "AM";
        strHour = "12";
      } else if (hour < 12) {
        ampm = "AM";
        if (hour < 10) {
          strHour = "0" + hour;
        } else {
          strHour = hour.toString();
        }
      } else if (hour < 24) {
        ampm = "PM";
        var result = ((hour + 11) % 12) + 1;
        if (result < 10) {
          strHour = "0" + result;
        } else {
          strHour = result.toString();
        }
      }

      return strHour + ":" + obj_time[1] + " " + ampm;
    }
  }
  return "";
}

export function GetFormattedDateWithTimeString(value_date, value_time) {
  if (value_date) {
    let obj_date = new Date(value_date.replace("00:00:00", value_time));
    if (obj_date) {
      let month = "" + (obj_date.getMonth() + 1);
      let day = "" + obj_date.getDate();
      let year = obj_date.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/") + " " + obj_date.toLocaleTimeString();
    }
  }

  return "";
}

export function GetFormattedDateDayWithTimeString(value_date, value_time) {
  if (value_date) {
    let obj_date = new Date(value_date.replace("00:00:00", value_time));
    if (obj_date) {
      let month = "" + (obj_date.getMonth() + 1);
      let day = "" + obj_date.getDate();
      let year = obj_date.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let dayName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      return (
        dayName[obj_date.getDay()] +
        " " +
        [day, month, year].join("/") +
        " " +
        obj_date.toLocaleTimeString()
      );
    }
  }

  return "";
}

export function GetAllowedHour(time_first, time_second) {
  let allowed_time = [];
  if (time_first) {
    allowed_time = allowed_time.concat([8, 9, 10, 11]);
  }
  if (time_second) {
    allowed_time = allowed_time.concat([13, 14, 15, 16]);
  }

  return allowed_time;
}

export function GetAllowedHourSelectList(time_first, time_second, isBoth) {
  let allowed_time = [];
  if (time_first) {
    allowed_time.push({
      text: "8AM - 12PM",
      value: "08:00:00",
      session: 1,
      type: 1
    });
  }
  if (time_second) {
    allowed_time.push({
      text: "1PM - 5PM",
      value: "13:00:00",
      session: 1,
      type: 2
    });
  }

  if (isBoth) {
    if (time_first && time_second) {
      allowed_time.push({
        text: "8AM - 5PM",
        value: "08:00:00",
        session: 2,
        type: 3
      });
    }
  }

  return allowed_time;
}

export function GetDateRange(selected_option, custom_date) {
  let from_date = null;
  let to_date = null;
  if (selected_option == TYPE_DATEFILTER_STATUS.TODAY.ID) {
    let today = new Date();
    from_date = GetFormattedLocaleDateOnlyString(today);
    to_date = GetFormattedLocaleDateOnlyString(today);
  } else if (selected_option == TYPE_DATEFILTER_STATUS.THIS_WEEK.ID) {
    let today = new Date();
    // total day in week is `7`, sunday `0` till next saturday `6)
    // to get first date of the week, we need to know the current date `day` number and minus it
    let first_day = today.getDate() - today.getDay();
    // after we get the first week date, then we plus `6 saturday number` to get the last day of the current week
    let last_day = first_day + 6;

    from_date = GetFormattedLocaleDateOnlyString(
      new Date(today.setDate(first_day))
    );
    to_date = GetFormattedLocaleDateOnlyString(
      new Date(today.setDate(last_day))
    );
  } else if (selected_option == TYPE_DATEFILTER_STATUS.THIS_MONTH.ID) {
    let today = new Date();
    from_date = GetFormattedLocaleDateOnlyString(
      new Date(today.getFullYear(), today.getMonth(), 1)
    );
    to_date = GetFormattedLocaleDateOnlyString(
      new Date(today.getFullYear(), today.getMonth() + 1, 0)
    );
  } else if (selected_option == TYPE_DATEFILTER_STATUS.PAST_7_DAYS.ID) {
    let today = new Date();

    from_date = GetFormattedLocaleDateOnlyString(
      new Date().setDate(today.getDate() - 7)
    );
    to_date = GetFormattedLocaleDateOnlyString(new Date());
  } else if (selected_option == TYPE_DATEFILTER_STATUS.PAST_30_DAYS.ID) {
    let today = new Date();

    from_date = GetFormattedLocaleDateOnlyString(
      new Date().setDate(today.getDate() - 30)
    );
    to_date = GetFormattedLocaleDateOnlyString(new Date());
  } else if (selected_option == TYPE_DATEFILTER_STATUS.CUSTOM_DATE.ID) {
    if (custom_date) {
      from_date = custom_date.from;
      to_date = custom_date.to;
    }
  }
  return {
    from: `${from_date}T00:00:00`,
    to: `${to_date}T23:59:59`
  };
}
